import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps, webpageProps } from 'js/analytics/standardizedProps'

export const trackEnterCoupon = ({ coupon }) => {
  ga.track('enter_code', { coupon: coupon })
  // NOTE: schema has no coupon-entry event; mapped to user_interact_object.
  // FLAG: the coupon value itself has no standardized property on this event.
  amplitude.track('user_interact_object', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'click',
    action_type: 'active',
    object_name: 'enter_coupon_code',
  })
}
